module.exports = __webpack_public_path__ + "img/itc.272f10f2.svg";